import React from 'react';

import {
  SidePage,
  Typography,
  DescriptionItem,
  Grid,
  Stack,
  Section,
  makeStyles,
} from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import { AffectedEntitiesSection } from 'scenes/SmartRules/components/AffectedEntities';
import { RunResults } from 'scenes/SmartRules/components/RunResults';

const useStyles = makeStyles({
  container: {
    overflowX: 'auto',
    maxHeight: 'calc(100vh - 350px)',
    maxWidth: '710px',
  },
});

export const SmartRuleAffectedEntitiesDetails = ({
  data,
  subTitle,
  onClose,
  onExited,
  open,
}) => {
  const classes = useStyles();
  const numberFormatter = useNumberFormat();

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Smart Rule Affected Entities Details'}
        subTitle={subTitle}
      />
      <SidePage.NewBody wrapper={true}>
        <SidePage.NewContent withSidebar={true}>
          {data ? (
            <React.Fragment>
              <Section title={'Results'}>
                <RunResults data={data} />
              </Section>

              <Section
                title={`Affected Entities (${numberFormatter(
                  data.affectedEntitiesCount
                )})`}
                isCollapsable={true}
                initialOpen={false}
              >
                <Stack className={classes.container}>
                  <AffectedEntitiesSection data={{ ...data, ...data.data }} />
                </Stack>
              </Section>
            </React.Fragment>
          ) : null}
        </SidePage.NewContent>
        <SidePage.Sidebar>
          <Grid item container xs={3} spacing={1} alignContent={'flex-start'}>
            <Grid item xs={12}>
              <Stack alignItems={'end'}>
                <Typography variant={'caption'}># {data.ruleId}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <DescriptionItem
                variant={'column'}
                label={'Date run'}
                type={'date'}
                value={data?.dateAdded}
              />
            </Grid>
          </Grid>
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};
